import React from 'react';
import ReactDOM from 'react-dom';
import './Assets/components/Index.scss';
import App from './App';

ReactDOM.render(
    <App />,
  document.getElementById('root')
);
